export const EVENT_GLOBAL_MSG_RCVD = 'event-global-msg-rcvd';
